import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import SiteContainer from '../../../components/layout/SiteContainer'
import HelmetTitle from '../../../components/layout/HelmetTitle'
import ContainerHeading from '../../../components/layout/ContainerHeading'
import ArrowRightBoldCircle from '../../../components/icons/ArrowRightBoldCircle'
import { H1, GridContainer, GridSection, Column, ListRow, ColumnStyle, ColumnResponsiveInnerContainer, ActionColumnStyleRightAligned, ActionIconContainer, NavBar, NavFwdBackButton } from '../../../components/management/styled-elements'

class ManagementSites extends React.Component {

  routeTo = (route) => {
    this.props.dispatch(push(route))
  }

  backToManagement = () => {
    const prevRoute = '/management'
    if (window.lastLocation && (window.lastLocation.host===window.location.host)) {
      this.props.history.goBack()
    } else {
      this.props.dispatch(push(prevRoute))
    }
  }

  renderSiteMenu() {
    return <div>
      <NavBar>
        <NavFwdBackButton onClick={this.backToManagement.bind(this)}>&#171; Back to Management</NavFwdBackButton>
      </NavBar>
      <GridContainer>
        <ContainerHeading title={`Sites Management`} />
        <GridSection>
          <ListRow divisions={12} key={0} onClick={this.routeTo.bind(this,'/management/sites/edit')}>
            <Column xs={10} style={ColumnStyle}><ColumnResponsiveInnerContainer>Edit a Site</ColumnResponsiveInnerContainer></Column>
            <Column xs={2} style={ActionColumnStyleRightAligned}><ActionIconContainer><ArrowRightBoldCircle right /></ActionIconContainer></Column>
          </ListRow>
          <ListRow divisions={12} key={1} onClick={this.routeTo.bind(this,'/management/sites/duplicate')}>
            <Column xs={10} style={ColumnStyle}><ColumnResponsiveInnerContainer>Duplicate a Site</ColumnResponsiveInnerContainer></Column>
            <Column xs={2} style={ActionColumnStyleRightAligned}><ActionIconContainer><ArrowRightBoldCircle right /></ActionIconContainer></Column>
          </ListRow>
        </GridSection>
      </GridContainer>
    </div>
  }

  renderBody = (props,state) => {
    console.log('this.props',this.props)
    console.log('this.props.history.location.pathname',this.props.history.location.pathname)
    return <div>
      { this.renderSiteMenu(props.apiAuth.user) }
    </div>
  }

  render = () => <SiteContainer isSignedIn={this.props.apiAuth.isSignedIn}>
    <HelmetTitle title={'Manage Sites'} />
    { this.renderBody(this.props,this.state) }
  </SiteContainer>

}

export default connect(
  (store, props) => ({
    apiAuth: store.apiAuth,
  }),
)(ManagementSites)



// WEBPACK FOOTER //
// ./src/containers/management/sites/index.js